<cmps-wait-status *ngIf="hasPendingData"></cmps-wait-status>
<div *ngIf="!hasPendingData && data == null">
    {{ i18n._711_NO_DATA_AVAILABLE | translate }}
</div>
<ng-container *ngIf="!hasPendingData && data != null">
    <ngb-tabset
        [activeId]="'w-tab-' + options?.pillarIndex"
        #tabSet="ngbTabset"
    >
        <ng-template
            ngFor
            let-i
            let-ii="index"
            [ngForOf]="data.items"
        >
            <ngb-tab [id]="'w-tab-' + ii">
                <ng-template ngbTabTitle>{{ i.name }}</ng-template>
                <ng-template ngbTabContent>
                    <div class="table-responsive">
                        <table
                            class="table table-striped table-sm table-bordered cmps-widget-table"
                        >
                            <thead class="thead-light">
                                <tr>
                                    <th rowspan="2">
                                        {{ i18n._778_PERSON | translate }}
                                    </th>
                                    <th rowspan="2">
                                        {{ i18n._67_SUPERGROUP | translate }}
                                    </th>
                                    <th rowspan="2">
                                        {{ i18n._752_SCORE | translate }}
                                    </th>
                                    <th rowspan="2">
                                        {{ i18n._779_OPP_ITEMS | translate }}
                                    </th>
                                    <th rowspan="2">
                                        {{
                                            i18n._780___OF_TEAM_OPP_ITEMS
                                                | translate
                                        }}
                                    </th>
                                    <th colspan="2">
                                        {{
                                            i18n._781_GENERAL_COMPLIANCE
                                                | translate
                                        }}
                                    </th>
                                    <th colspan="2">
                                        {{
                                            i18n._782_POLICY___AUTO | translate
                                        }}
                                    </th>
                                    <th colspan="2">
                                        {{
                                            i18n._783_POLICY___RESI | translate
                                        }}
                                    </th>
                                </tr>
                                <tr>
                                    <th>{{ i18n._752_SCORE | translate }}</th>
                                    <th>
                                        {{ i18n._779_OPP_ITEMS | translate }}
                                    </th>
                                    <th>{{ i18n._752_SCORE | translate }}</th>
                                    <th>
                                        {{ i18n._779_OPP_ITEMS | translate }}
                                    </th>
                                    <th>{{ i18n._752_SCORE | translate }}</th>
                                    <th>
                                        {{ i18n._779_OPP_ITEMS | translate }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container
                                    *ngTemplateOutlet="
                                        row;
                                        context: { j: i.user, rowTop: true }
                                    "
                                ></ng-container>
                                <ng-container *ngIf="i.overall">
                                    <ng-container
                                        *ngTemplateOutlet="
                                            row;
                                            context: {
                                                j: i.overall,
                                                rowTop: true
                                            }
                                        "
                                    ></ng-container>
                                </ng-container>
                            </tbody>
                        </table>
                    </div>
                    <div class="table-responsive">
                        <table
                            class="table table-striped table-sm table-bordered table-hover cmps-widget-table"
                        >
                            <thead class="thead-light">
                                <tr>
                                    <th rowspan="2">
                                        {{ i18n._778_PERSON | translate }}
                                    </th>
                                    <th rowspan="2">
                                        {{ i18n._67_SUPERGROUP | translate }}
                                    </th>
                                    <th rowspan="2">
                                        {{ i18n._752_SCORE | translate }}
                                    </th>
                                    <th rowspan="2">
                                        {{ i18n._779_OPP_ITEMS | translate }}
                                    </th>
                                    <th rowspan="2">
                                        {{
                                            i18n._780___OF_TEAM_OPP_ITEMS
                                                | translate
                                        }}
                                    </th>
                                    <th colspan="2">
                                        {{
                                            i18n._781_GENERAL_COMPLIANCE
                                                | translate
                                        }}
                                    </th>
                                    <th colspan="2">
                                        {{
                                            i18n._782_POLICY___AUTO | translate
                                        }}
                                    </th>
                                    <th colspan="2">
                                        {{
                                            i18n._783_POLICY___RESI | translate
                                        }}
                                    </th>
                                    <th
                                        class="sr-only"
                                        rowspan="2"
                                    >
                                        {{ i18n._746_DETAILS | translate }}
                                    </th>
                                </tr>
                                <tr>
                                    <th>{{ i18n._752_SCORE | translate }}</th>
                                    <th>
                                        {{ i18n._779_OPP_ITEMS | translate }}
                                    </th>
                                    <th>{{ i18n._752_SCORE | translate }}</th>
                                    <th>
                                        {{ i18n._779_OPP_ITEMS | translate }}
                                    </th>
                                    <th>{{ i18n._752_SCORE | translate }}</th>
                                    <th>
                                        {{ i18n._779_OPP_ITEMS | translate }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-template
                                    ngFor
                                    let-j
                                    let-jj="index"
                                    [ngForOf]="i.team"
                                >
                                    <ng-container
                                        *ngTemplateOutlet="
                                            row;
                                            context: { j: j, rowTop: false }
                                        "
                                    ></ng-container>
                                </ng-template>
                            </tbody>
                        </table>
                    </div>
                </ng-template>
            </ngb-tab>
        </ng-template>
    </ngb-tabset>
    <div
        class="card"
        *ngIf="!!currentDetail"
        #popupEl
    >
        <div class="card-header">
            <span>{{ i18n._784_COMPAS | translate }}</span>
            <button
                type="button"
                class="close ml-3"
                [attr.aria-label]="i18n._763_CLOSE | translate"
                (click)="currentDetail = null"
            >
                <cmps-icon svgIcon="close"></cmps-icon>
            </button>
        </div>
        <div class="card-body">
            <cmps-widget-tdbfg-compliance-details
                [user]="currentDetail"
                [widgetId]="options.widgetId"
                [activeTabId]="activeTabId"
            ></cmps-widget-tdbfg-compliance-details>
        </div>
    </div>
</ng-container>

<ng-template
    let-j="j"
    let-rowTop="rowTop"
    #row
>
    <tr (click)="rowTop ? false : showDetails(j)">
        <td class="text-nowrap">{{ j.username }}</td>
        <td class="text-nowrap">{{ j.superGroupName }}</td>
        <td>
            <span [ngStyle]="{ color: j.score.thresholdColor }">{{
                j.score.value | number: '1.0-0'
            }}</span>
            <cmps-icon
                [style.fill]="j.score.trendClass.split(' ')[0].toLowerCase()"
                [svgIcon]="j.score.trendClass.split(' ')[1].toLowerCase()"
                *ngIf="j.score.trendClass?.split(' ')?.length > 1"
            ></cmps-icon>
        </td>
        <td>{{ j.score.oppItems }}</td>
        <td>
            {{
                j.percentOfTeam == null
                    ? (i18n._842_N_A | translate)
                    : (j.percentOfTeam | percent: '1.1-1')
            }}
        </td>
        <td>
            <span [ngStyle]="{ color: j.compliance.thresholdColor }">{{
                j.compliance.value | number: '1.0-0'
            }}</span>
            <cmps-icon
                [style.fill]="
                    j.compliance.trendClass.split(' ')[0].toLowerCase()
                "
                [svgIcon]="j.compliance.trendClass.split(' ')[1].toLowerCase()"
                *ngIf="j.compliance.trendClass?.split(' ')?.length > 1"
            ></cmps-icon>
        </td>
        <td>{{ j.compliance.oppItems }}</td>
        <td>
            <span [ngStyle]="{ color: j.auto.thresholdColor }">{{
                j.auto.value | number: '1.0-0'
            }}</span>
            <cmps-icon
                [style.fill]="j.auto.trendClass.split(' ')[0].toLowerCase()"
                [svgIcon]="j.auto.trendClass.split(' ')[1].toLowerCase()"
                *ngIf="j.auto.trendClass?.split(' ')?.length > 1"
            ></cmps-icon>
        </td>
        <td>{{ j.auto.oppItems }}</td>
        <td>
            <span [ngStyle]="{ color: j.resi.thresholdColor }">{{
                j.resi.value | number: '1.0-0'
            }}</span>
            <cmps-icon
                [style.fill]="j.resi.trendClass.split(' ')[0].toLowerCase()"
                [svgIcon]="j.resi.trendClass.split(' ')[1].toLowerCase()"
                *ngIf="j.resi.trendClass?.split(' ')?.length > 1"
            ></cmps-icon>
        </td>
        <td>{{ j.resi.oppItems }}</td>
        <td
            class="sr-only"
            *ngIf="!rowTop"
        >
            <button
                type="button"
                class="cmps-btn-table"
                (click)="showDetails(j)"
            >
                Show details
            </button>
        </td>
    </tr>
</ng-template>
